import { PRICE_DISPLAY_OPTIONS, PRICE_TYPES, getPriceDisplayOptionById, getPriceTypeByName } from '../constants/market.constant';
import { PriceType } from './market.model';

export class PriceConfiguration {
  averageNumberOfDays: number = 7;
  priceType: PriceType = PRICE_TYPES.sell;
  priceDisplayOption: PriceDisplayOption = PRICE_DISPLAY_OPTIONS.single;

  constructor() {}

  static fromJson(json: string): PriceConfiguration{
    
    const plainObject = JSON.parse(json);

    const result: PriceConfiguration = Object.assign(new PriceConfiguration(), plainObject);

    result.priceType = getPriceTypeByName(result.priceType.name);
    
    result.priceDisplayOption = getPriceDisplayOptionById(result.priceDisplayOption.id);

    return result;
  }
}

export class PriceDisplayOption {
  id: number;
  name: string;

  constructor(id: number, name: string){
    this.id = id;
    this.name = name;
  }
}

export function createPriceDisplayOption(id: number, name: string): PriceDisplayOption{
  return {id, name};
}
